import React, { useEffect } from 'react';
import { LinearProgress } from '@material-ui/core';
import { connect } from 'react-redux';
import { redirectToSecure } from '../../components/Authenticate/Authenticate';
import { getDashboard, getDashboardReset } from '../../actions';

const LoadingRoute = ({
    getDashboard,
    getDashboardReset,
    getDashboardSuccess
}) => {
    useEffect(() => {
        getDashboard();
    }, [getDashboard]);

    useEffect(() => {
        if (getDashboardSuccess) {
            redirectToSecure();
            getDashboardReset();
        }
    }, [getDashboardSuccess, getDashboardReset]);

    // Normal login
    return (
        <>
            <LinearProgress />
        </>
    );
};


export default connect(
    state => ({
        getDashboardSuccess: state.app.getDashboardSuccess
    }), {
        getDashboard,
        getDashboardReset
    }
)(LoadingRoute);